import {
  CCol,
  CRow
} from "@coreui/react";
import React from "react";
import {
  NEXT_PAYMENT_LABEL,
  NEXT_PAYMENT_DATE_LABEL,
  EPO_AMOUNT
} from "../../AppConstants";

const QuickDetailItem = ({paymentScheduleInfo}) => {
  let {nextPaymentAmount, nextPaymentDueDate, epoAmount, epoEndDate, epoEndDateLabel} = paymentScheduleInfo;

  return (
    <>
      <CRow>
        <CCol sm="2">
          <div className="nextPaymentIcon"/>
        </CCol>
        <CCol sm="10">
          <div className="quickDetailsItemDescription">
            <span className="quickDetailsLabel">{NEXT_PAYMENT_LABEL}: </span>
            {nextPaymentAmount ?
              <span className="medium"> ${nextPaymentAmount}</span> :
              <span className="medium">N/A</span>}
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <hr/>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <div className="nextPaymentDateIcon"/>
        </CCol>
        <CCol sm="10">
          <div className="quickDetailsItemDescription">
            <span className="quickDetailsLabel">{NEXT_PAYMENT_DATE_LABEL}: </span>
            {nextPaymentDueDate ?
              <span className="medium">{nextPaymentDueDate}</span> :
              <span className="medium">N/A</span>}
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <hr/>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <div className="epoEndDateIcon"/>
        </CCol>
        <CCol sm="10">
          <div className="quickDetailsItemDescription">
            <span className="quickDetailsLabel">{epoEndDateLabel}: </span>
            {epoEndDate ?
              <span className="medium">{epoEndDate}</span> :
              <span className="medium">N/A</span>}
          </div>
        </CCol>
      </CRow>
      <CRow><CCol sm="12"><hr/></CCol></CRow>
      <CRow>
        <CCol sm="2">
          <div className="epoAmountIcon"/>
        </CCol>
        <CCol sm="10">
          <div className="quickDetailsItemDescription">
            <span className="quickDetailsLabel">{EPO_AMOUNT}: </span>
            {epoAmount ?
              <span className="medium">${epoAmount}</span> :
              <span className="medium">N/A</span>}
          </div>
        </CCol>
      </CRow>
    </>
  )
}

export default QuickDetailItem;
